import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from '../hooks/use-toast';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Admin credentials validation
    const validEmail = 'Admin@dropsquadz.tech';
    const validPasswords = ['Aditya110409@#', '8819001865', 'DropSquadz11@#'];

    if (formData.email === validEmail && validPasswords.includes(formData.password)) {
      const adminUser = {
        principalId: 'admin_principal',
        clientId: 1000,
        email: validEmail,
        role: 'admin',
        name: 'Admin'
      };
      localStorage.setItem('admin', JSON.stringify(adminUser));
      toast({
        title: 'Success',
        description: 'Admin login successful',
      });
      navigate('/admin/panel');
    } else {
      toast({
        title: 'Error',
        description: 'Invalid admin credentials',
        variant: 'destructive',
      });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-blue-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white border-slate-200 shadow-xl">
        <CardHeader>
          <div className="flex flex-col items-center space-y-4">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-lg shadow-blue-500/30">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <CardTitle className="text-2xl md:text-3xl text-center text-blue-600">
              Admin Login
            </CardTitle>
            <p className="text-slate-500 text-center text-sm">DropSquadz Admin Panel</p>
          </div>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-slate-700">Admin Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="Admin@dropsquadz.tech"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="bg-slate-50 border-slate-200 focus:border-blue-500 focus:ring-blue-500/20"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-700">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter admin password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="bg-slate-50 border-slate-200 focus:border-blue-500 focus:ring-blue-500/20"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg shadow-blue-500/30"
            >
              {loading ? 'Logging in...' : 'Login as Admin'}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-slate-500 hover:text-blue-600"
            >
              Back to Home
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;